import React, { useEffect } from "react";
import { Formik, Form, Field } from "formik";
import Select from "react-select";
import { getCurrentDate } from "../../../../Common/helper/helpar";
import { useDrainSlitComplaintReportStore } from "./useDrainSlitComplaintReportStore";
import DrainSlitComplaintTable from "./DrainSlitComplaintTable";
import ModalComponent from "../../../../Common/popup_modal/ModalComponent";
import ComplaintDetailsPopup from "./ComplaintDetailsPopup";
import AssignComplaintDetailsPopup from "./AssignComplaintDetailsPopup";

const toWardOption = (ward) => ({
  value: String(ward.circleId ?? ward.wardId ?? ""),
  label: ward.circleName ?? ward.wardName ?? ward.wardNo ?? "",
});

const DrainSlitComplaintReportView = () => {
  const {
    wards,
    fetchWards,
    complaintStatuses,
    fetchComplaintStatuses,
    setViewComplaintDetailsModal,
    viewComplaintDetailsModal,
    setAssignComplaintDetailsModal,
    AssignComplaintDetailsModal,
    fetchDrainSlitComplaintOuterReport,
  } = useDrainSlitComplaintReportStore();

  const initialValues = {
    wardId: "",
    Status: "",
    fromDate: getCurrentDate(),
    toDate: getCurrentDate(),
  };

  const onSubmit = (values) => {
    fetchDrainSlitComplaintOuterReport({
      WardId: values.wardId,
      Status: values.Status,
      FromDate: values.fromDate,
      ToDate: values.toDate,
      PageNumber: 1,
      PageSize: 10,
    });
  };

  useEffect(() => {
    fetchWards();
    fetchComplaintStatuses();
    fetchDrainSlitComplaintOuterReport({
      WardId: "",
      Status: "",
      FromDate: getCurrentDate(),
      ToDate: getCurrentDate(),
      PageNumber: 1,
      PageSize: 10,
    });
  }, []);

  return (
    <>
      <div className="card shadow mt-1">
        <div className="card-body">
          <Formik initialValues={initialValues} enableReinitialize onSubmit={onSubmit}>
            {({ values, setFieldValue }) => (
              <Form>
                <div className="row align-items-center">
                  {/* from date */}
                  <div className="col-md-2 mb-3">
                    <label className="form-label">From Date</label>
                    <Field
                      type="date"
                      name="fromDate"
                      className="form-control bg-white"
                      max={values.toDate || getCurrentDate()}
                      onChange={(e) => {
                        const newFrom = e.target.value;
                        setFieldValue("fromDate", newFrom);
                        if (values.toDate && newFrom > values.toDate) {
                          setFieldValue("toDate", newFrom);
                        }
                      }}
                    />
                  </div>

                  {/* to date */}
                  <div className="col-md-2 mb-3">
                    <label className="form-label">To Date</label>
                    <Field
                      type="date"
                      name="toDate"
                      className="form-control bg-white"
                      min={values.fromDate || ""}
                      max={getCurrentDate()}
                    />
                  </div>

                  {/* ward dropdown */}
                  <div className="col-md-2 mb-3">
                    <label className="form-label">Ward</label>
                    <Select
                      inputId="wardId"
                      name="wardId"
                      classNamePrefix="react-select"
                      options={wards.map(toWardOption)}
                      value={
                        wards
                          .map(toWardOption)
                          .find((option) => option.value === String(values.wardId)) ||
                        null
                      }
                      onChange={(selected) =>
                        setFieldValue("wardId", selected ? selected.value : "")
                      }
                      placeholder="Select Ward"
                      isClearable={false}
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>

                  {/* complaint status dropdown */}
                  <div className="col-md-2 mb-3">
                    <label className="form-label">Complaint Status</label>
                    <Field as="select" name="Status" className="form-select bg-white">
                      <option value="">Select Status</option>
                      {complaintStatuses.map((status) => (
                        <option
                          key={status.complaintStatusId}
                          value={status.complaintStatusName}
                        >
                          {status.complaintStatusName}
                        </option>
                      ))}
                    </Field>
                  </div>

                  {/* apply filters button */}
                  <div className="d-flex col-md-3 gap-2 mt-3">
                    <button
                      type="submit"
                      style={{
                        backgroundColor: "#003366",
                        color: "#FFFFFF",
                        border: "none",
                        fontWeight: 600,
                        padding: "6px 16px",
                        borderRadius: "6px",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      APPLY FILTERS
                    </button>
                    <button
                      type="reset"
                      style={{
                        backgroundColor: "#FDE8E8",
                        color: "#8B1A1A",
                        border: "none",
                        fontWeight: 600,
                        padding: "6px 16px",
                        borderRadius: "6px",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        boxShadow: "0 2px 4px rgba(139, 26, 26, 0.15)",
                      }}
                      onClick={() => {
                        initialValues.fromDate = getCurrentDate();
                        initialValues.toDate = getCurrentDate();
                        initialValues.wardId = "";
                        initialValues.Status = "";
                        fetchDrainSlitComplaintOuterReport({
                          WardId: "",
                          Status: "",
                          FromDate: getCurrentDate(),
                          ToDate: getCurrentDate(),
                          PageNumber: 1,
                          PageSize: 10,
                        });
                      }}
                    >
                      RESET
                    </button>
                  </div>

                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="card-body">
          <DrainSlitComplaintTable />
        </div>
      </div>
      {/* view complaint details modal */}
      <ModalComponent
        title="Complaint Details"
        show={viewComplaintDetailsModal}
        onHide={() => { setViewComplaintDetailsModal(false); }}
        size="lg"
        handleClose={() => { setViewComplaintDetailsModal(false); }}
      >
        {/* Dynamic content inside the modal body */}
        <div>
          <ComplaintDetailsPopup />
        </div>
      </ModalComponent>

      {/* assign complaint details modal */}
      <ModalComponent
        title="Assign Complaint To"
        show={AssignComplaintDetailsModal}
        onHide={() => { setAssignComplaintDetailsModal(false); }}
        size="lg"
        handleClose={() => { setAssignComplaintDetailsModal(false); }}
      >
        {/* Dynamic content inside the modal body */}
        <div>
          <AssignComplaintDetailsPopup />
        </div>
      </ModalComponent>
    </>
  );
};

export default DrainSlitComplaintReportView;
